export default __webpack_public_path__ + "static/images/byp-header-m.f2186d809680df7c30fcd75edacd5e01.png";